/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ButtonComponent } from "../../../button/button.component";
import { TableAction, TableActionsParams } from "../../../../models/ui/table-actions-params.model";

@Component({
	selector: "globalictcc-table-actions",
	standalone: true,
	imports: [ButtonComponent],
	templateUrl: "./table-actions.component.html",
	styleUrl: "./table-actions.component.scss"
})
export class TableActionsComponent implements ICellRendererAngularComp {
	public rowData: unknown;
	public actions: TableAction[] = [];

	/**
	 * Initializes the table action component with the provided parameters.
	 *
	 * @param params - The parameters for the table action component.
	 */
	public agInit(params: TableActionsParams) {
		this.refresh(params);
	}

	/**
	 * Refreshes the table action component with new parameters.
	 *
	 * @param params - The parameters containing the data and actions to refresh the component.
	 * @returns A boolean indicating the refresh was successful.
	 */
	public refresh(params: TableActionsParams): boolean {
		this.rowData = params.data;
		this.actions = params.actions;

		return true;
	}
}
